import React, {useEffect, useState} from "react";
import axiApi from "ApiCaller";
import {useParams} from "react-router-dom";
import NavBreadcrumb from "../../components/NavBreadcrum";
import {useTranslation} from "react-i18next";
import moment from "moment";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {languagesSelect} from "core/languages";
import navs from "./navs";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {SwalAlertClass} from "core/swalClass";

const DocumentationDetail = () => {
    const {id} = useParams();
    const [lines, setLines] = useState([]);
    const [relatedDocuments, setrelatedDocuments] = useState([]);
    const [availableLanguages, setAvailableLanguages] = useState([]);
    const [activeLanguage, setActiveLanguage] = useState(
        localStorage.getItem("i18nextLng") || "es"
    );
    const {t: _tR} = useTranslation("routes");
    const {t: _tT} = useTranslation("tables");

    const {version} = useParams();
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

    const bread = [
        {
            name: _tR("labels.documentation"),
            url: "/documentation/",
            current: false,
        },
        {
            name: _tR("labels.document"),
            url: `/documentation/${version}/`,
            current: true,
        },
    ];

    useEffect(() => {
        axiApi
            .get(`/api/loggers/documentation/${version}/`)
            .then((resp) => {
                // console.log("Documentation details:", resp.data);
                setLines(resp.data.document_lines);
                setrelatedDocuments(resp.data.documents);

                setAvailableLanguages([
                    ...new Set(resp.data.document_lines.map((line) => line.language)),
                ]);

                if (resp.data.document_lines.length > 0) {
                    if (activeLanguage) {
                        if (
                            !resp.data.document_lines.some(
                                (desc) => desc.language === activeLanguage
                            )
                        ) {
                            setActiveLanguage(resp.data.document_lines[0].language);
                        }
                    } else {
                        setActiveLanguage(resp.data.document_lines[0].language);
                    }
                }
            })
            .catch((e) => {
                console.error("Error fetching release details:", e);
            });
    }, [id]);

    const getLanguageName = (langKey) => {
        const langObject = languagesSelect.find((lang) => lang.key === langKey);
        return langObject ? langObject.name : langKey;
    };

    const onClickLink = (e) => {
        let link = e.target.dataset.link;
        if (!link) {
            Alert.error("Archivo", "No se pudo encontrar la referencia del archivo");
            return false;
        }
        axiApi
            .get(`/api/loggers/documentation/download/${link}`, {
                responseType: "blob",
            })
            .then((resp) => {
                const contentDisposition = resp.headers["content-disposition"];
                const contentType = resp.headers["content-type"];
                let filename = "downloaded-file";
                if (contentDisposition) {
                    const filenameMatch =
                        contentDisposition.match(/filename="?([^"]+)"?/);
                    if (filenameMatch && filenameMatch.length === 2) {
                        filename = filenameMatch[1];
                    }
                }
                const blob = new Blob([resp.data], {type: contentType});
                const urlBlob = window.URL.createObjectURL(blob);
                const linkTemp = document.createElement("a");
                linkTemp.href = urlBlob;
                linkTemp.setAttribute("download", filename);

                document.body.appendChild(linkTemp);
                linkTemp.click();
                document.body.removeChild(linkTemp);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <>
            <NavBreadcrumb navs={navs} bread={bread} />
            <div className="mt-4">
                <h3 className="mb-4">{_tR("labels.documentation-list")} </h3>
                {availableLanguages.length > 0 ? (
                    <Tabs
                        activeKey={activeLanguage}
                        onSelect={(k) => setActiveLanguage(k)}
                        id="language-tabs"
                        className="mb-4">
                        {availableLanguages.map((lang) => (
                            <Tab
                                key={lang}
                                eventKey={lang}
                                title={getLanguageName(lang)}>
                                {relatedDocuments.map((related) => (
                                    <li key={related.id} className="mb-4 list-unstyled">
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}>
                                            <h5 className="mb-1">
                                                <strong>{related.version}</strong>
                                            </h5>
                                            <div>{related.title}</div>
                                            <small className="text-muted">
                                                {moment(related.created_at).format(
                                                    "MMMM D, YYYY"
                                                )}
                                            </small>
                                        </div>
                                        <ul className="mt-2">
                                            {lines
                                                .filter(
                                                    (line) =>
                                                        line.language === lang &&
                                                        line.document_id === related.id
                                                )
                                                .map((line) => (
                                                    <li key={line.id} className="mb-3">
                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <div className="d-flex align-items-center">
                                                                <h6 className="font-weight-bold mb-0">
                                                                    {line.title}&nbsp;
                                                                    {line.is_admin && (
                                                                        <span className="badge bg-primary ms-1">
                                                                            {_tT(
                                                                                "users.is_admin"
                                                                            )}
                                                                        </span>
                                                                    )}
                                                                    {line.is_tech && (
                                                                        // !line.is_admin &&
                                                                        <span className="badge bg-secondary ms-1">
                                                                            {_tT(
                                                                                "users.is_tech"
                                                                            )}
                                                                        </span>
                                                                    )}
                                                                </h6>
                                                            </div>
                                                            {line.document_file && (
                                                                <div
                                                                    key={line.id}
                                                                    className="d-flex align-items-center">
                                                                    <button
                                                                        type="button"
                                                                        data-link={
                                                                            line.id
                                                                        }
                                                                        className="btn btn-sm btn-outline-primary"
                                                                        onClick={
                                                                            onClickLink
                                                                        }>
                                                                        Descargar{" "}
                                                                        <FontAwesomeIcon icon="file-export" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="mb-3">
                                                            <p
                                                                style={{
                                                                    whiteSpace:
                                                                        "pre-wrap",
                                                                }}>
                                                                {line.description}
                                                            </p>
                                                        </div>
                                                    </li>
                                                ))}
                                        </ul>
                                    </li>
                                ))}
                            </Tab>
                        ))}
                    </Tabs>
                ) : (
                    <p>No hay información disponible en ningún idioma.</p>
                )}
            </div>
        </>
    );
};

export default DocumentationDetail;
